import { useState, useEffect, SetStateAction, Dispatch } from 'react';

/** input 창에 포커스가 되었는지의 여부를 체크 - 닫기 아이콘의 활성화 여부를 결정하기 위해 사용 */
const useSearchInputFocusCheck = <T extends HTMLElement>(
	input_ref: HTMLElement | null,
	dependency: any[] = [],
): [boolean, Dispatch<SetStateAction<boolean>>] => {
	const [input_on, setInputOn] = useState(false);

	const _document = typeof document === 'object' ? document : { activeElement: '' };

	useEffect(() => {
		if (!document || input_ref === null) return;

		if (document.activeElement === input_ref) setInputOn(true);
		else if (document.activeElement !== input_ref) setInputOn(false);

		const inputFocus = () => setInputOn(true);
		const inputBlur = () => {
			setTimeout(() => setInputOn(false), 300);
		};

		input_ref.addEventListener('focus', inputFocus);
		input_ref.addEventListener('blur', inputBlur);

		return () => {
			input_ref.removeEventListener('focus', inputFocus);
			input_ref.removeEventListener('blur', inputBlur);
		};
	}, [input_ref, input_on, ...dependency, _document?.activeElement]);

	return [input_on, setInputOn];
};

export default useSearchInputFocusCheck;
